import { useMemo } from "react"
import { isNonEmptyArray } from "@tm/utils"
import { useCondensedChatInfos } from "."
import { openWorkTask } from "../../bundle-channel"
import { getBundleParams } from "../../utils"

export function useOpenArticleListWithProductGroup(chatId: string, productGroupIds?: number[], vehicleInfoId?: string) {
    const infos = useCondensedChatInfos(chatId)

    const vehicle = useMemo(() => infos?.vehicles.find((v) => v.vehicleInfo.id === vehicleInfoId), [infos, vehicleInfoId])

    const handleOpenArticleListWithProductGroups = useMemo(() => {
        if (vehicle) {
            const route = getBundleParams().articleListProductGroups

            if (route && isNonEmptyArray(productGroupIds)) {
                return () => {
                    openWorkTask({
                        selectedChatVehicle: vehicle,
                        subRoute: `${route}?productGroupIds=${productGroupIds.join(",")}`,
                        skipRenderRoute: true,
                    })
                }
            }
        }
    }, [vehicle, productGroupIds])

    return { handleOpenArticleListWithProductGroups }
}
